export namespace EventTracker {
    export function init() {
    }

    export function track(_event: string) {
    }
}
